/**
 * Format a date string to a readable format
 * @param dateString - ISO date string from Contentful
 * @returns Formatted date string (e.g., "June 10, 2025")
 */
export function formatDateLong(dateString: string | undefined | null): string | null {
    if (!dateString) return null;

    try {
        const date = new Date(dateString);
        // Check if date is valid
        if (isNaN(date.getTime())) return null;

        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    } catch {
        return null;
    }
}
